import { useFormik } from "formik";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { plasticAddSite } from "../../../schema";
import AdminListService from "../../../services/admin-list.service";
import Footer from "../includes/Footer";
import Sidebar from "../includes/Sidebar";
import { CKEditor } from "ckeditor4-react";
import he from "he";

export default function AddSitePlastic() {
  const state = useSelector((state) => state.stateVals);

  const { admin_id } = state;
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const addPlasticSite = async (values, action) => {
    setLoading(true);

    try {
      const responce = await AdminListService.sitePlasticAdd(values, admin_id);

      if (responce.status === 200) {
        setLoading(false);
        Swal.fire({
          icon: "success",
          title: "Added Successfully!",
          showConfirmButton: false,
          timer: 1500,
        });

        setTimeout(() => {
          navigate("/pickyourplastic_manage");
        }, 1500);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      if (
        err?.response?.data?.message &&
        typeof err?.response?.data?.message === "string"
      ) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          iconColor: "#e04f5d",
          text: err?.response?.data?.message,
          confirmButtonColor: "#e72e2e",
          confirmButtonText: "Try Again",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          iconColor: "#e04f5d",
          text: "Some thing went wrong!",
          confirmButtonColor: "#e72e2e",
          confirmButtonText: "Try Again",
        });
      }
    }
  };

  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      siteName: "",
      userName: "",
      password: "",
      email: "",
      visio: "",
      pedType: "",
      subject: "",
      body: '<table align="center" border="0" cellpadding="10" style="margin-top:50px;width:900px"><tbody><tr><td colspan="2" style="text-align:center"><img alt="logo" src="https://images-cloud.s3.ap-south-1.amazonaws.com/evoucherthanks.PNG"></td></tr><tr><td colspan="2" style="text-align:center"><span style="color:#00f"><span style="color:#2e74b5;font-family:times new roman,times,serif"><span style="font-size:28px"><strong>$sitename</strong></span></span></span></td></tr><tr><td colspan="2" style="text-align:center"><span style="font-size:20px"><strong>To redeem your gift card go to<br><a href="https://ashleytestrest.com" style="color: rgb(46, 116, 181); text-decoration: none;">www.ashleytestrest.com</a></strong></span></td></tr><tr><td colspan="2" style="text-align:center"><span style="color:#b22222"><span style="font-size:18px"><strong>PLEASE do not forget to write down your certificate number BEFORE entering the site.</strong></span></span></td></tr><tr><td colspan="2" style="text-align:center"><div class="background" style="font-size:18px"><strong><span style="font-size:20px">Voucher #</span>:</strong><span style="font-size:20px"><span style="color:#b22222">$cert</span></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong><span style="font-size:20px">Voucher Value</span>:</strong><span style="font-size:20px"><span style="color:#b22222">$val</span></span></div></td></tr><tr><td colspan="2" style="text-align:center"><table align="center" border="0" cellpadding="5" style="color:#414141;font-size:26px;width:900px"><tbody><tr><td style="text-align:center"><span style="font-family:times new roman,times,serif"><span style="color:grey">$Cards_name</span></span></td></tr></tbody></table></td></tr><tr><td colspan="2" style="text-align:center"><table align="center" border="0" cellpadding="5" style="color:#414141;font-size:18px;width:900px"><tbody><tr><td style="text-align:center"><strong>Offer not valid after Expiration Date of</strong><span style="color:#000"><strong>:</strong>$expiry date</span></td></tr></tbody></table></td></tr><tr><td colspan="2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>Reward CardTerms and Conditions:</strong><ul><li>Elite Rewards reserves the right to substitute a comparable reward card.</li><li>Only one voucher can be redeemed per household per month.</li><li>All taxes are the responsibility of the person receiving the redemption.</li><li>Once your voucher is redeemed allow 2-4 weeks for processing and delivery. The card you selected will be sent to you via the US Postal Service or by email where virtual-cards are available. Failure to adhere to all Terms &amp; Conditions may hinder the processing of your reward card.</li><li>No duplicates of this voucher will be accepted.</li><li>Failure to complete any line of online redemption form will result in this voucher being returned to you and will cause a delay in processing.<br>.</li></ul></td></tr><tr><td colspan="2" style="text-align:center"><h3><strong>For Questions related to gift cards please call 1-866 ELITE-21</strong></h3>&nbsp;<p style="text-align:left"><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;FST No. for Elite Rewards: ST 39966</strong></p></td></tr></tbody></table>',
    },
    validationSchema: plasticAddSite,
    onSubmit: (values, action) => {
      addPlasticSite(values, action);
    },
  });

  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <Sidebar />

          <div className="card">
            <div className="card-header py-3">
              <h5 className="mb-0 font-22">Add Customer</h5>
            </div>

            <div className="card-body">
              <form className="row g-3" onSubmit={handleSubmit} noValidate>
                <div className="col-12 col-md-4">
                  <label className="form-label">Site Name </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Site Name"
                    name="siteName"
                    value={values.siteName || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.siteName && touched.siteName ? (
                    <span className="text-danger">{errors.siteName}</span>
                  ) : null}
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">Username</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Username"
                    name="userName"
                    value={values.userName || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.userName && touched.userName ? (
                    <span className="text-danger">{errors.userName}</span>
                  ) : null}
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">Password </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Password"
                    name="password"
                    value={values.password || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.password && touched.password ? (
                    <span className="text-danger">{errors.password}</span>
                  ) : null}
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">Email </label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    name="email"
                    value={values.email || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.email && touched.email ? (
                    <span className="text-danger">{errors.email}</span>
                  ) : null}
                </div>

                <div className="col-12 col-md-4">
                  <label className="form-label">Na-visio Number</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Na-visio Number"
                    name="visio"
                    value={values.visio || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.visio && touched.visio ? (
                    <span className="text-danger">{errors.visio}</span>
                  ) : null}
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">Product Type</label>
                  <select
                    className="form-select"
                    name="pedType"
                    value={values.pedType || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <option value="">Product Type</option>
                    <option value="Ordinary PYP">Ordinary PYP</option>
                    <option value="Gorilla PYP">Gorilla PYP</option>
                  </select>
                  {errors.pedType && touched.pedType ? (
                    <span className="text-danger">{errors.pedType}</span>
                  ) : null}
                </div>

                <div className="col-12 col-md-7">
                  <label htmlFor="formFileMultiple" className="form-label">
                    Auto Generated Email Subject
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Subject"
                    name="subject"
                    value={values.subject || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.subject && touched.subject ? (
                    <span className="text-danger">{errors.subject}</span>
                  ) : null}
                </div>

                <div className="col-12 col-md-12">
                  <label htmlFor="formFileMultiple" className="form-label">
                    Email body
                  </label>

                  <CKEditor
                    initData={values.body || ""}
                    config={{
                      allowedContent: true,
                      versionCheck: false,

                      toolbar: [
                        ["Source"],
                        ["Styles", "Format", "Font", "FontSize"],
                        [
                          "Cut",
                          "Copy",
                          "Paste",
                          "PasteText",
                          "PasteFromWord",
                          "-",
                          "Undo",
                          "Redo",
                        ],
                        [
                          "Bold",
                          "Italic",
                          "Strike",
                          "UnderLine",
                          "RemoveFormat",
                        ],
                        ["Link", "Unlink", "Anchor"],
                        [
                          "NumberedList",
                          "BulletedList",
                          "-",
                          "Outdent",
                          "Indent",
                          "-",
                          "Blockquote",
                          "CreateDiv",
                          "-",
                          "JustifyLeft",
                          "JustifyCenter",
                          "JustifyRight",
                          "JustifyBlock",
                          "-",
                          "BidiLtr",
                          "BidiRtl",
                          "Language",
                        ],
                        ["EasyImageUpload"],
                        ["TextColor", "BGColor"],
                        ["Maximize", "ShowBlocks"],
                      ],
                      extraPlugins: "easyimage",
                      removePlugins: "image",
                      cloudServices_uploadUrl:
                        "https://33333.cke-cs.com/easyimage/upload/",
                      cloudServices_tokenUrl:
                        "https://33333.cke-cs.com/token/dev/ijrDsqFix838Gh3wGO3F77FSW94BwcLXprJ4APSp3XQ26xsUHTi0jcb1hoBt",
                    }}
                    onInstanceReady={(e) => {
                      var data = e.editor.getData();

                      const encodedHTML = he.encode(data);
                      setFieldValue("body", encodedHTML);
                    }}
                    onChange={(e) => {
                      var data = e.editor.getData();

                      const encodedHTML = he.encode(data);
                      setFieldValue("body", encodedHTML);
                    }}
                  />
                </div>

                <hr />

                <div className="col-md-4 m-0">
                  <div className="d-flex h-100 w-100 align-items-end mb-mob">
                    <button className="btn btn-primary w-100">
                      Save Customer Record
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </div>
  );
}
